import React, { useEffect, useRef } from "react"
import * as styles from "./Video.module.css"

type VideoProps = {
  url: string
}

const Video = ({ url }: VideoProps) => {
  const videoRef = useRef<HTMLIFrameElement | null>(null)

  useEffect(() => {
    const handleScroll = () => {
      const videoElement = videoRef.current

      if (videoElement) {
        const rect = videoElement.getBoundingClientRect()
        const isVideoInView = rect.top <= window.innerHeight && rect.bottom >= 0

        if (isVideoInView) {
          videoElement.contentWindow?.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            "*"
          )
        } else {
          videoElement.contentWindow?.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*"
          )
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <div className={styles.container}>
      <iframe
        ref={videoRef}
        title="PressNXpress"
        src={url}
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  )
}

export default Video
